import {
  AppRootElementBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { AppUpdateNotification } from './AppUpdateNotification';

export const appUpdateNotificationModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    AppRootElementBlueprint.make({
      name: 'app-update-notification',
      params: { element: <AppUpdateNotification /> },
    }),
  ],
});
